import SocialShare from './social-share';
import Facebook from './social-facebook';
import Email from './social-email';
import Linkedin from './social-linkedin';
import Twitter from './social-twitter';
import WhatsApp from './social-whatsapp';
import Google from './social-google';

export {
	SocialShare,
	Facebook,
	Email,
	Linkedin,
	Twitter,
	WhatsApp,
	Google,
};



// WEBPACK FOOTER //
// ../shared/components/social/index.js